import axios from "axios";
import { API_CLIENT_DOMAIN } from "../constants";
import { handleError } from "../errorHandler";

export const getApplicationVersionSigning = (
  id: number,
  onSuccess: Function,
  onFailure: Function
) => {
  axios
    .get(API_CLIENT_DOMAIN + "/signing/" + id)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch(function (error) {
      handleError(error, onFailure);
    });
};
